import { createSlice, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {IIndexable} from "../../../../domain/interfaces";
import {default as cloneDeep} from "lodash/cloneDeep";
import {ContactFormDataEx, ContactFormDataSend, OptionLabelValue, PopupSetupType} from "../interfaces";
import {getJSONFromHtml} from "../../../../domain/common";
import {getHiddenDataBoolean} from "../../../../domain/hidden-data-provider";



const sfFormData =getJSONFromHtml(document.getElementById('contact-form-data')) as ContactFormDataSend;
const sfFormDataEX =getJSONFromHtml(document.getElementById('contact-form-data-ex')) as ContactFormDataEx;
var ddlPhoneCounties: OptionLabelValue[] = [];
var ddlsetupList: OptionLabelValue[] = [];
//console.log('sfFormDataEX: ',sfFormDataEX);

/*-------------------------------------------------------------------------phoneCountries*/
if(sfFormDataEX && sfFormDataEX?.phoneCountries && sfFormDataEX?.phoneCountries.length > 0){

    //ddlPhoneCounties =  [{label: 'Select ...', value: 0, id: 0}];
    sfFormDataEX.phoneCountries.forEach((se: any) => {
        const _value = se["country2Digit"];
        let _label = `${se["countryDisplayName"]} +${se["phoneCode"]}`;
        const _id = se["countryID"];

        let ddlObj: OptionLabelValue = {value: _value, label: _label, id: _id};
        ddlPhoneCounties?.push(ddlObj);
    });
}
/*-------------------------------------------------------------------------setupList*/
if(sfFormDataEX && sfFormDataEX?.setupRecordList && sfFormDataEX?.setupRecordList.length > 0){
    sfFormDataEX.setupRecordList.forEach((sl: any) => {
        const _value = sl["id"];
        let _label = `${sl["name"]}`;
        const _id = sl["id"];

        let ddlObj: OptionLabelValue = {value: _value, label: _label, id: _id};
        ddlsetupList?.push(ddlObj);
    });
}
export interface StateInterface extends IIndexable{
    sfFormData: ContactFormDataSend,
    sfFormDataEX: ContactFormDataEx,
    phoneCountries: OptionLabelValue[],
    setupList: OptionLabelValue[]

    setupID: string;
    popupSetup: PopupSetupType;
    popupSetupId: string;

}
// initial state
const initialState: StateInterface = {
    sfFormData: sfFormData,
    sfFormDataEX: sfFormDataEX,
    phoneCountries: ddlPhoneCounties,
    setupList: ddlsetupList,

    setupID : 'test setupID',
    popupSetup: PopupSetupType.Hidden,
    popupSetupId: ""
}
// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
        setControl(state, action) {

            return {
                ...state,
                [action.payload.controlName]: cloneDeep(action.payload.control),
            }
        },
    },
});

const store = configureStore({
    reducer: rootSlice.reducer,
});

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
